import { ComputeExpenseReportTotalsUseCase } from './ComputeExpenseReportTotals'

export { ComputeExpenseReportTotalsUseCase }

export const computeExpenseReportTotalsUseCase =
  new ComputeExpenseReportTotalsUseCase()
